<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.65689 21.0032L3 21.0032L3.00003 15.3464L14.1503 4.19998C15.7128 2.63801 18.246 2.63922 19.807 4.2027C21.3664 5.76463 21.3654 8.29472 19.8047 9.85542L8.65689 21.0032ZM15.9587 10.8731L7.82846 19.0032L5.00001 19.0032L5.00003 16.175L13.1317 8.04614L15.9587 10.8731ZM17.3729 9.45886L18.3905 8.4412C19.1706 7.66112 19.1711 6.3965 18.3916 5.6158C17.6114 4.83433 16.3453 4.83372 15.5643 5.61444L14.5462 6.63217L17.3729 9.45886Z"
      fill="#202020"
    />
  </svg>
</template>
